const state = () => ({
  blocks: [
    {
      title: 'Перед началом обучения',
      image: 'https://frontend-scripts.hb.bizmrg.com/unique-hf/png/smile-v.png',
      groups: [
        {
          title: 'Программы обучения',
          link: '/cost',
          articles: [
            {
              title: 'Основные программы обучения',
              link: '/blog/vidy-programm-obrazovaniya'
            },
            {
              title: 'GeekSchool',
              link: '/courses/geek-school'
            }
          ],
          isShowMore: false
        }
      ]
    },
    {
      title: 'Студентам',
      image:
        'https://frontend-scripts.hb.bizmrg.com/unique-hf/png/smile-university.png',
      groups: [
        {
          title: 'О процессе обучения',
          link: '/generalquestions',
          articles: [
            {
              title: 'Буткемп',
              link: '/blog/bootcamp'
            }
          ],
          isShowMore: false
        },
        {
          title: 'О портале',
          link: '/generalquestionsforgeekschool',
          articles: [
            {
              title: 'Журнал, мероприятия, форум',
              link: '/topics'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Для обучения',
          link: '/techquestions',
          articles: [
            {
              title: 'Программное обеспечение и студенческие лицензии',
              link: '/softwarelicencesforstudents'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Центр карьеры',
          link: '/softwareinstructions',
          articles: [
            {
              title: 'Помощь с поиском работы',
              link: '/career'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Дополнительно',
          link: '/literatureandsourcesforstudents',
          articles: [
            {
              title:
                'Реферальная программа',
              link: '/programreferral'
            },
            {
              title: 'Налоговый вычет',
              link: '/blog/kak-poluchit-vychet-za-obuchenie'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Как оценить качество обучения',
          link: '/educationquality',
          articles: [
            {
              title: 'Вы можете помочь нам повысить качество обучения',
              link: '/educationquality'
            }
          ],
          isShowMore: false
        }
      ]
    },
    {
      title: 'Экспертам',
      image:
        'https://frontend-scripts.hb.bizmrg.com/unique-hf/png/smile-coder.png',
      groups: [
        {
          title: 'Экспертам',
          link: '/academiccertificates',
          articles: [
            {
              title: 'Инструкция',
              link: '/teacher_help'
            },
            {
              title: 'Возможности',
              link: '/opportunitiesforexperts'
            },
            {
              title: 'Реферальная программа',
              link: '/bringanexpert'
            }
          ],
          isShowMore: false
        }
      ]
    },
    {
      title: 'База знаний Центра карьеры',
      image:
        'https://frontend-scripts.hb.bizmrg.com/unique-hf/png/smile-glasses.png',
      groups: [
        {
          title: 'Поиск работы',
          link: '/teacher_help',
          articles: [
            {
              title: 'Поиск вакансий и отклики',
              link: '/responsestovacanciesandjobsearch'
            },
            {
              title: 'Подготовка к поиску работы',
              link: '/preparationforajobsearch'
            },
            {
              title: 'Резюме (CV)',
              link: '/curriculumvitae'
            },
            {
              title: 'Сопроводительное письмо (CL)',
              link: '/coverletter'
            },
            {
              title: 'Портфолио',
              link: '/howtomakeaportfolio'
            },
            {
              title: 'Частые вопросы о поиске работы',
              link: '/careerfaq'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Собеседование и оффер',
          link: '/formentors',
          articles: [
            {
              title: 'Подготовка к собеседованию',
              link: '/preparationforajobinterview'
            },
            {
              title: 'Предложение о работе и трудоустройство',
              link: '/offerandemployment'
            }
          ],
          isShowMore: false
        },
        {
          title: 'Фриланс',
          link: '/formentors',
          articles: [
            {
              title: 'Рекомендации для фрилансеров',
              link: '/advicesforfreelancers'
            },
            {
              title: 'Поиск работы в других странах',
              link: '/abroadjobsearch'
            }
          ],
          isShowMore: false
        }
      ]
    }
  ]
})

const getters = {
  getBlocks(state) {
    return state.blocks.filter(block => block.groups?.length > 0)
  }
}

export { state, getters }
